(function () {
    let timeout;
    let observer;
    let isBound = false;

    const runTrustpilot = () => {
        if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== 'function') return;

        document.querySelectorAll('.trustpilot-widget').forEach((el) => {
            window.Trustpilot.loadFromElement(el);
        });
    };

    const bindObserver = () => {
        if (isBound) return;

        const container = document.querySelector('#ProductGridContainer');
        if (!container) return;

        observer = new MutationObserver(() => {
            clearTimeout(timeout);
            timeout = setTimeout(runTrustpilot, 250);
        });

        observer.observe(container, {
            childList: true,
            subtree: true
        });

        isBound = true;
        runTrustpilot();
    };

    document.addEventListener('DOMContentLoaded', bindObserver);
    document.addEventListener('shopify:section:load', bindObserver);

    const fallbackObserver = new MutationObserver(() => {
        if (!isBound && document.querySelector('#ProductGridContainer')) {
            bindObserver();
        }
    });

    fallbackObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
})();
